<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii">THE TROUBLE WITH TEA</a></h1><a id="page_iii">
<p class="subtitle"><em>The Politics of Consumption in the Eighteenth-Century Global Economy</em></p>
<p class="center"><img alt="images" src="images/f0iii-01.jpg"/></p>
<p class="author">Jane T. Merritt</p>
<p class="center"><span class="small">OLD DOMINION UNIVERSITY</span></p>
<p class="center"><em>Norfolk, Virginia</em></p>
<p class="pub">Johns Hopkins University Press</p>
<p class="center"><em>Baltimore</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?58b76756